if(typeof __WEBPACK_EXTERNAL_MODULE__7606__ === 'undefined') { var e = new Error("Cannot find module 'hammerjs'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__7606__;